<div id="content-wrapper" [@fadeInOnEnter] [@fadeOutOnLeave]>
  <ng-container *ngIf="twoColumns; else static">
    <ng-container [ngTemplateOutlet]="twoCol"></ng-container>
  </ng-container>
  <nibtravel-sidebar
    *ngIf="showSidebarHost$ | async"
    [@fadeInOnEnter]
    [@fadeOutOnLeave]
  >
    <ng-content
      select="[main-sidebar]"
      ngProjectAs="main-sidebar-content"
    ></ng-content>
  </nibtravel-sidebar>
</div>

<ng-template #twoCol>
  <ng-container [ngTemplateOutlet]="hero"></ng-container>
  <div [class]="mainContentCss">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
    <aside class="sidebar sidebar--inverse">
      <ng-content select="[sidebar]"></ng-content>
    </aside>
  </div>
</ng-template>

<ng-template #static>
  <ng-container [ngTemplateOutlet]="hero"></ng-container>
  <div [class]="mainContentCss">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </div>
</ng-template>

<ng-template #content>
  <main class="main-content">
    <ng-content select="[main-content]"></ng-content>
  </main>
</ng-template>

<ng-template #hero>
  <ng-content select="[hero-content]"></ng-content>
</ng-template>
